import React, { useEffect, useContext, useState, useRef } from 'react'
import {useParams} from 'react-router-dom'
import Loader from '../Loader/Loader'
import StateContext from "../../StateContext"
import DispatchContext from "../../DispatchContext"
import { Link, withRouter } from 'react-router-dom'

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import AlertMessage from '../ReusableComponents/AlertMessage'

import AddMedia from '../Media/AddMedia'
import ImagePicker from '../Media/ImagePicker'
import AddIngredientsPost from './AddIngredientsPost'
import AddCategoryPost from './AddCategoryPost'
import AddAllergyFriendliness from './AddAllergyFriendliness'
import AddIngredients from './PostComponents/AddIngredients'



import { firestore } from '../../firebase'
import EditIngredients from './PostComponents/EditIngredients'
import AddInstructions from './PostComponents/AddInstructions'
import EditInstructions from './PostComponents/EditInstructions'
import MediaUpload from '../Media/MediaUpload'
import AddCategories from './PostComponents/AddCategories'
import EditCategories from './PostComponents/EditCategories'
import AddMainCategory from './PostComponents/AddMainCategory'

function EditPost(props) {

    const {id} = useParams();
    const appState = useContext(StateContext)
    const appDispatch = useContext(DispatchContext)

    const [recipe, setRecipe] = useState()

    const [isLoading, setIsLoading] = useState(true)
    const [isSaving, setIsSaving] = useState(false)
    const [notFound, setNotFound] = useState(false);

    const [sendCount, setSendCount] = useState(0);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState()
    const [alertMessage, setAlertMessage] = useState("")
    
    // POST CONTENT
    const [authorName, setAuthorName] = useState("")
    const [title, setTitle] = useState()
    const [description, setDescription] = useState("")
    const [servings, setServings] = useState(4)
    const [prepTime, setPrepTime] = useState(20)
    const [featuredImageRecipe, setFeaturedImageRecipe] = useState("https://camillahardilla.com/wp-content/uploads/2019/04/img_8219-1024x683.jpg");
    const [mainCategory, setMainCategory] = useState();

    const [ingredients, setIngredients] = useState()

    // ALLERGIES AND DIET
    const [dietDescription, setDietDescription] = useState()

    const uploadMedia = useRef(null)
    const [activeItem, setActiveItem] = useState("1")

    const [categoryIds, setCategoryIds] = useState([])

   

    function submitHandler(e) {
        e.preventDefault()
        setSendCount(sendCount+1);
    }

    useEffect(() => {


        async function fetchPost() {
            setIsLoading(true)
            try {

                const postRef = firestore.collection("recipes").doc(id)

                postRef.onSnapshot(doc => {
                    const recipe = {id: doc.id, ...doc.data()}
                    setRecipe(recipe)
                })
                
              
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
            
        }
        fetchPost();
    }, [])

    useEffect(() => {

        if (recipe) {

            setTitle(recipe.title)
            setPrepTime(recipe.preparation_time);
            setServings(recipe.portions);
            setDescription(recipe.description);
            setFeaturedImageRecipe(recipe.imageUrl)
            setDietDescription(recipe.diet)
            setAuthorName(recipe.author_name)
            setIngredients(recipe.ingredients)
            setMainCategory(recipe.category_id)
            
            //console.log(response.data.acf.ingredients, " ACF FIELDS POST")
            if (appState.userId !== recipe.author_id) {
                console.log(appState.userId, "!==", recipe.author_id)
                setShowAlert(true);
                setAlertType("danger");
                setAlertMessage("Du har ikke rettighet til å redigere dette innlegget")

                //props.history.push("/");
            } else {
                setShowAlert(false)
            }
            //console.log("OPPSKRIFT: ", response.data)
        } else {

            setShowAlert(true);
            setAlertType("danger");
            setAlertMessage("Fant ikke innlegg")
        }

    }, [id, recipe])

    useEffect(() => {

        if (sendCount) {

            async function editPost(e) {

                setIsSaving(true);

                if (!title || !description || !featuredImageRecipe || !prepTime || !servings || !dietDescription || !authorName || !mainCategory) {
                    setAlertMessage("Fyll ut alle feltene")
                    setShowAlert(true);
                    setAlertType("danger");
                    setIsSaving(false)
                    return
                }
                
                try {

                    const editedPost = {
                        title,
                        description,
                        imageUrl: featuredImageRecipe,
                        portions: servings,
                        preparation_time: +prepTime,
                        diet: dietDescription,
                        author_name: authorName,
                        category_id: mainCategory,
                        categories: categoryIds
    
                    }
    
                    const recipeRef = await firestore.collection("recipes").doc(id).update(editedPost)

                    if (recipeRef) {
                        console.log(recipeRef)
                    }
    
                    appDispatch({type: "flashMessage", value: "Innlegg er oppdatert!"})
                    setShowAlert(true);
                    setAlertType("success");
                    setAlertMessage("Innlegg oppdatert!")
                    
                } catch (error) {
                    console.log(error)

                    setShowAlert(true);
                    setAlertType("danger");
                    setAlertMessage("Kunne ikke redigere")
                }

                setIsSaving(false)
                
            }
            editPost();
        }

    }, [sendCount])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }



    if (notFound) {
        return (
            <p>Not found... <Link to="/">Home</Link></p>
            
        )
    }

    if (isLoading || !recipe) return <Loader />

    if (!appState.loggedIn) return <p>You must be logged in</p>

    return (
        <div className="container my-4">
            
            <Link className="small font-weight-bold my-3" to={`/innlegg/single/${recipe.id}`}>Back to recipe page</Link>
            <br />

            {activeItem === "1" &&

            <>

                <form className="mt-3" onSubmit={submitHandler}>
                    <div className="form-group">
                        <label htmlFor="post-title" className="text-muted mb-1">
                            <small>Title</small>
                        </label>
                        <input  
                            onChange={e => setTitle(e.target.value)} 
                            value={title} 
                            autoFocus 
                            name="title" 
                            id="post-title" 
                            className="form-control form-control-lg form-control-title" 
                            type="text" 
                            placeholder="" 
                            autoComplete="off" 
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="author_name" className="text-muted mb-1">
                            <small>Forfatter</small>
                        </label>
                        <input  
                            onChange={e => setAuthorName(e.target.value)} 
                            value={authorName} 
                            autoFocus 
                            name="author_name" 
                            id="author_name" 
                            className="form-control form-control-lg form-control-title" 
                            type="text" 
                            placeholder="" 
                            autoComplete="off" 
                        />
                    </div>

                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Add recipe picture</small>
                    </label>
                    <ImagePicker 
                        setFeaturedImageRecipe={setFeaturedImageRecipe} 
                        type="recipeImageUrl"
                    />
                    <input value={featuredImageRecipe} type="text" name="field[fremhevet_bilde_oppskrift" onChange={e => setFeaturedImageRecipe(e.target.value)} className="form-control mb-2" placeholder="Recipe picture" />
                    
                    
                    {featuredImageRecipe && <div className="col-md-3"><img src={featuredImageRecipe} className="img-fluid" /></div>}

                    <div className="btn btn-success btn-rounded" onClick={() => toggle("2")}>Last opp bilde</div>

                    <br/>

                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Short Description</small>
                    </label>
                    <textarea 
                        onChange={(e) => setDescription(e.target.value)} 
                        value={description}
                        name="fields[beskrivelse_oppskrift]" 
                        placeholder="Recipe description" 
                        className="form-control mb-2" 
                    />

                    <AddMainCategory mainCategory={mainCategory} setMainCategory={setMainCategory} />
                    
                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Total servings</small>
                    </label>
                    <input 
                        onChange={(e) => setServings(e.target.value)} 
                        value={servings} 
                        type="number" 
                        name="fields[antall_serveringer]" 
                        placeholder="Portions" 
                        className="form-control mb-2" 
                    />
                    
                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Prep Time</small>
                    </label>
                    <input 
                        onChange={(e) => setPrepTime(e.target.value)} 
                        value={prepTime} 
                        type="number" 
                        name="fields[forberedelse_oppskrift]" 
                        placeholder="Total time" 
                        className="form-control mb-2" 
                    />


                    <label htmlFor="post-title" className="text-muted mb-1">
                        <small>Diets</small>
                    </label>
                    <input onChange={(e) => setDietDescription(e.target.value)} value={dietDescription} name="fields[diet_description]" placeholder="Diet(s)" className="form-control mb-2" />

                    <br/>



                    <button className="wp-button wp-button-primary my-3" disabled={isSaving}> {!isSaving ? "Save New Post" : "Updating"} </button>
                    {isSaving && <div className="alert alert-success">Lagrer</div>}
                    {!isSaving && <AlertMessage showAlert={showAlert} alertType={alertType} alertMessage={alertMessage} setShowAlert={setShowAlert} />}
                    <Link className="small font-weight-bold my-3 ml-3" to={`/innlegg/single/${recipe.id}`}>Back to recipe page</Link>
                </form>

                <div className="my-4">
                    <h5 className="font-weight-bold my-4">Selected categories</h5>
                    <EditCategories recipeId={id} setCategoryIds={setCategoryIds} />
                    <h5 className="font-weight-bold my-4">Add category</h5>
                    <AddCategories recipeId={id} />
                </div>

                <div className="my-3">
                    <h5 className="font-weight-bold mb-3">Edit ingredients</h5>
                    
                    <EditIngredients recipeId={id} />
                    <h5 className="font-weight-bold my-4">Add ingredients</h5>
                    <AddIngredients recipeId={id} />
                </div>
                
                <h5 className="font-weight-bold mt-4">Edit instructions</h5>
                <EditInstructions recipeId={id} />
                <h5 className="font-weight-bold mt-4">Legg til instruksjon</h5>
                <AddInstructions recipeId={id} />
                </>
            }

            {activeItem === "2" && 

                <div>
                    <div className="btn btn-success btn-rounded" onClick={() => toggle("1")} >Back to edit</div>
                    <MediaUpload />
                </div>
            }
            

        </div>
    )
}
export default withRouter(EditPost)